(function () {
  var LB_PER_KG = 2.2046226218;
  var CM_PER_IN = 2.54;

  function roundInput(value) {
    return Math.round(value * 10) / 10;
  }

  function initialize(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var form = root.querySelector('[data-size-form]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-size-card]'));
    var unitButtons = Array.prototype.slice.call(root.querySelectorAll('[data-unit-button]'));
    var result = root.querySelector('[data-size-result]');
    var resultSize = root.querySelector('[data-result-size]');
    var resultDetails = root.querySelector('[data-result-details]');
    var resultLink = root.querySelector('[data-result-link]');
    var toast = root.querySelector('[data-size-toast]');
    var toastSize = root.querySelector('[data-toast-size]');
    var toastAdd = root.querySelector('[data-toast-add]');
    var toastTimer;
    var selectedCard;

    function getInput(name) {
      return root.querySelector('[data-measurement="' + name + '"]');
    }

    function clearSelection() {
      cards.forEach(function (card) {
        card.classList.remove('is-selected');
        card.setAttribute('aria-pressed', 'false');
      });
    }

    function restartAnimation(node) {
      if (!node) return;
      node.classList.remove('is-animating');
      void node.offsetWidth;
      node.classList.add('is-animating');
    }

    function hideToast() {
      if (!toast) return;
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }

    function scheduleToastHide(delay) {
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(hideToast, delay || 6000);
    }

    function showToast(card) {
      if (!toast || !toastSize) return;
      window.clearTimeout(toastTimer);
      toastSize.textContent = card.dataset.size;
      if (toastAdd) {
        var isAvailable = card.dataset.variantAvailable === 'true' && Boolean(card.dataset.variantId);
        toastAdd.hidden = false;
        toastAdd.disabled = !isAvailable;
        toastAdd.dataset.variantId = card.dataset.variantId || '';
        toastAdd.dataset.state = isAvailable ? 'ready' : 'sold-out';
        toastAdd.textContent = isAvailable
          ? root.dataset.addLabel || 'Add to cart'
          : root.dataset.soldOutLabel || 'Sold out';
      }
      toast.setAttribute('aria-hidden', 'false');
      toast.classList.add('is-visible');
      scheduleToastHide(10000);
    }

    function findNativeProductForm() {
      var productId = root.dataset.productId;
      var forms = Array.prototype.slice.call(document.querySelectorAll('product-form-component'));
      return forms.find(function (component) {
        return component.dataset.productId === productId && component.querySelector('form[action*="/cart/add"]');
      });
    }

    function restoreNativeFormState(variantInput, previousVariantId, buttons, disabledStates) {
      variantInput.value = previousVariantId;
      variantInput.setAttribute('value', previousVariantId);
      buttons.forEach(function (button, index) {
        button.disabled = disabledStates[index];
      });
    }

    function submitSelectedVariant() {
      if (!toastAdd || !selectedCard || toastAdd.disabled) return;

      var variantId = selectedCard.dataset.variantId;
      var productForm = findNativeProductForm();
      var form = productForm && productForm.querySelector('form[action*="/cart/add"]');
      var variantInput = form && form.querySelector('input[name="id"]');
      if (!productForm || !form || !variantInput || !variantId) {
        toastAdd.textContent = root.dataset.cartErrorLabel || 'Try again';
        scheduleToastHide(5000);
        return;
      }

      window.clearTimeout(toastTimer);
      toastAdd.disabled = true;
      toastAdd.dataset.state = 'adding';
      toastAdd.textContent = root.dataset.addingLabel || 'Adding…';

      var previousVariantId = variantInput.value;
      var nativeButtons = Array.prototype.slice.call(productForm.querySelectorAll('button[name="add"]'));
      var disabledStates = nativeButtons.map(function (button) { return button.disabled; });
      var settled = false;

      function cleanup() {
        document.removeEventListener('cart:update', onCartUpdate);
        document.removeEventListener('cart:error', onCartError);
      }

      function finishWithError() {
        if (settled) return;
        settled = true;
        cleanup();
        toastAdd.disabled = false;
        toastAdd.dataset.state = 'error';
        toastAdd.textContent = root.dataset.cartErrorLabel || 'Try again';
        scheduleToastHide(5000);
      }

      function onCartError(event) {
        var sourceId = event && event.detail && event.detail.sourceId;
        if (!sourceId || sourceId === form.getAttribute('id')) finishWithError();
      }

      function onCartUpdate(event) {
        var eventData = event && event.detail && event.detail.data;
        if (!eventData || String(eventData.productId) !== String(root.dataset.productId)) return;
        if (settled || eventData.didError) {
          if (eventData.didError) finishWithError();
          return;
        }
        settled = true;
        cleanup();
        toastAdd.dataset.state = 'added';
        toastAdd.textContent = root.dataset.addedLabel || 'Added';
        scheduleToastHide(2600);
      }

      document.addEventListener('cart:update', onCartUpdate);
      document.addEventListener('cart:error', onCartError);

      variantInput.value = variantId;
      variantInput.setAttribute('value', variantId);
      nativeButtons.forEach(function (button) { button.disabled = false; });

      try {
        form.requestSubmit();
      } catch (error) {
        finishWithError();
      } finally {
        window.setTimeout(function () {
          restoreNativeFormState(variantInput, previousVariantId, nativeButtons, disabledStates);
        }, 0);
      }

      window.setTimeout(function () {
        if (!settled) finishWithError();
      }, 12000);
    }

    function selectCard(card, source) {
      if (!card) return;
      clearSelection();
      selectedCard = card;
      card.classList.add('is-selected');
      restartAnimation(card);
      card.setAttribute('aria-pressed', 'true');
      result.classList.remove('is-error');
      result.classList.add('is-active');
      restartAnimation(result);
      resultSize.textContent = card.dataset.size;
      resultDetails.textContent =
        'Supports up to ' + card.dataset.weightLb + ' lb / ' + card.dataset.weightKg + ' kg · B up to ' +
        card.dataset.bIn + ' in / ' + card.dataset.bCm + ' cm · C requires at least ' +
        card.dataset.cIn + ' in / ' + card.dataset.cCm + ' cm.';
      resultLink.href = card.dataset.variantUrl;
      resultLink.textContent = (root.dataset.selectLabel || 'Select') + ' ' + card.dataset.size;
      resultLink.hidden = false;
      showToast(card);

      if (source === 'recommendation') {
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    function showError(title, message) {
      clearSelection();
      selectedCard = null;
      hideToast();
      result.classList.remove('is-active', 'is-animating');
      result.classList.add('is-error');
      resultSize.textContent = title;
      resultDetails.textContent = message;
      resultLink.hidden = true;
    }

    function readMetricValues() {
      var unit = root.dataset.unit || 'imperial';
      var values = {
        weight: parseFloat(getInput('weight').value),
        a: parseFloat(getInput('a').value),
        b: parseFloat(getInput('b').value),
        c: parseFloat(getInput('c').value)
      };

      if (Object.keys(values).some(function (key) { return !Number.isFinite(values[key]) || values[key] <= 0; })) {
        return null;
      }

      if (unit === 'imperial') {
        values.weight = values.weight / LB_PER_KG;
        values.a = values.a * CM_PER_IN;
        values.b = values.b * CM_PER_IN;
        values.c = values.c * CM_PER_IN;
      }
      return values;
    }

    function findRecommendation(values) {
      return cards.find(function (card) {
        var bodyLengthFits = values.b <= parseFloat(card.dataset.bCm);
        var backLengthMeetsMinimum = values.c >= parseFloat(card.dataset.cCm);
        var weightFits = values.weight <= parseFloat(card.dataset.weightKg);
        var frontLegHeightFits = values.a >= parseFloat(card.dataset.aCm);
        return bodyLengthFits && backLengthMeetsMinimum && weightFits && frontLegHeightFits;
      });
    }

    function setUnit(nextUnit) {
      var currentUnit = root.dataset.unit || 'imperial';
      if (nextUnit === currentUnit) return;

      ['weight', 'a', 'b', 'c'].forEach(function (name) {
        var input = getInput(name);
        var value = parseFloat(input.value);
        if (!Number.isFinite(value)) return;
        var storedMetricValue = parseFloat(input.dataset.metricValue);
        if (!Number.isFinite(storedMetricValue)) {
          if (currentUnit === 'metric') {
            storedMetricValue = value;
          } else {
            storedMetricValue = name === 'weight' ? value / LB_PER_KG : value * CM_PER_IN;
          }
          input.dataset.metricValue = String(storedMetricValue);
        }

        input.value = roundInput(
          nextUnit === 'metric'
            ? storedMetricValue
            : name === 'weight'
              ? storedMetricValue * LB_PER_KG
              : storedMetricValue / CM_PER_IN
        );
      });

      root.dataset.unit = nextUnit;
      root.querySelectorAll('[data-weight-unit]').forEach(function (node) {
        node.textContent = nextUnit === 'metric' ? 'kg' : 'lb';
      });
      root.querySelectorAll('[data-length-unit]').forEach(function (node) {
        node.textContent = nextUnit === 'metric' ? 'cm' : 'in';
      });
      unitButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.unitButton === nextUnit));
      });
    }

    ['weight', 'a', 'b', 'c'].forEach(function (name) {
      var input = getInput(name);
      input.addEventListener('input', function () {
        var value = parseFloat(input.value);
        if (!Number.isFinite(value)) {
          delete input.dataset.metricValue;
          return;
        }
        var unit = root.dataset.unit || 'imperial';
        input.dataset.metricValue = String(
          unit === 'metric'
            ? value
            : name === 'weight'
              ? value / LB_PER_KG
              : value * CM_PER_IN
        );
      });
    });

    unitButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setUnit(button.dataset.unitButton);
      });
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectCard(card, 'manual');
      });
    });

    if (toastAdd) {
      toastAdd.addEventListener('click', submitSelectedVariant);
    }

    if (toast) {
      toast.addEventListener('pointerenter', function () { window.clearTimeout(toastTimer); });
      toast.addEventListener('pointerleave', function () { scheduleToastHide(5000); });
      toast.addEventListener('focusin', function () { window.clearTimeout(toastTimer); });
      toast.addEventListener('focusout', function () { scheduleToastHide(5000); });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var values = readMetricValues();
      if (!values) {
        showError('Complete all four measurements', 'Enter weight plus A, B, and C to receive an accurate recommendation.');
        return;
      }

      var recommendation = findRecommendation(values);
      if (!recommendation) {
        showError(
          'No exact match found',
          'Please review the measurements or contact us for sizing help. Your dog’s C measurement must be greater than or equal to the selected size requirement.'
        );
        return;
      }
      selectCard(recommendation, 'recommendation');
    });
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-jp-cushion-size-guide]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
